export default "__VITE_ASSET__Jp2GmhFp__"